import styled from "styled-components";

const ScanningResult = styled.div`
  position: relative;

  canvas {
    width: 100%;
    height: 100%;
  }

  .invisible {
    display: none;
  }
`;

export default ScanningResult;
